import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { jsonResponseHandler } from '../utils/FetchHelper'

import {closePopup, hideLoadingPopup, showErrorToastPopup, showLoadingPopup, showSkinSavePopup} from "../actions/popup";
import {connect} from "react-redux";
import SkinCard from "../components/design/skin/SkinCard";
import { isDescendant } from "../utils/DomHelper"
import autobind from 'autobind-decorator'
import LoadingBox from "../components/common/LoadingBox";
import CurrentSkin from "../components/design/skin/CurrentSkin";
import SkinPopupLayer from "../components/design/skin/SkinPopupLayer";
import WindowEventHelper from "../lib/WindowEventHelper";
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import { ARCHIVE } from '../constants/design/SkinTypes'
import {addPrefix} from "../utils/UriUtil";
import {CONFIRM_CHANGE_SKIN_MSG} from "../components/design/skin/SkinMsg";

@connect(state => ({

}), dispatch => ({
    handleShowSkinAddPopup: (title, description, callBack) => {
        dispatch(showSkinSavePopup(title, description, callBack))
    },
    handlePopupClose: () => {
        dispatch(closePopup())
    },
    handleShowErrorToastPopup: (title, description) => {
        dispatch(showErrorToastPopup(title, description))
    },
    handleShowLoadingPopup: (loadingPopupMessage) => {
        dispatch(showLoadingPopup(loadingPopupMessage))
    },
    handleHideLoadingPopup: () => {
        dispatch(hideLoadingPopup())
    },
    dispatch
}))
class SkinArchiveListApp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            initialized : InitStatus.INIT_READY,
            currentSkin: null,
            archiveList: [],
        }
    }

    componentDidMount() {
        this.init();
		WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleWindowClick)
    }

    @autobind
    handleWindowClick(e) {
        const { root } = this.refs
        let target = e.target

        if (!isDescendant(root, target)) {
            // this.handleClose()
        }
    }

    @autobind
    init() {
        this.setState({
            initialized: InitStatus.INIT_DOING,
		});

		this.fetch().catch(e => {
			console.error(e);
			this.setState({
				initialized : InitStatus.INIT_FAIL,
			})
		})
	}

	@autobind
    refetch() {
		this.fetch().catch(e => {
			console.error(e)
			alert("문제가 발생했습니다.")
		})
	}

	fetch() {
		const { dispatch } = this.props;

		return fetch(addPrefix("/manage/design/skin/archivelist.json"), {
            credentials: 'include',
            headers: {'Content-Type':'application/json'}
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                    currentSkin: data.currentSkin,
                    skinList: data.skinList,
                    archiveList: data.archiveList
                });
            })
	}

    @autobind
    handleSkinAdd() {
        this.props.history.push('/design/skin/add');
	}

	@autobind
    handleArchive(e) {

        const { dispatch } = this.props;

        e.preventDefault();
        e.stopPropagation();

        this.props.handleShowSkinAddPopup('스킨 보관','보관 시 HTML/CSS 편집 및 사이드바 설정 등의 정보까지 저장됩니다. 스킨은 최대 30개까지 저장할 수 있습니다.', (archiveName)=>{
            this.props.handlePopupClose();
			this.props.handleShowLoadingPopup('저장 중입니다.');

			let formdata = new FormData()
			formdata.append("skinname", archiveName)
			formdata.append("originalname", this.state.currentSkin.name)

			fetch(addPrefix("/manage/design/skin/archive.json"), {
				method: 'post',
				credentials: "include",
				body: formdata
			})
				.then(jsonResponseHandler(dispatch))
				.then(r => r.json())
				.then(data => {
					this.props.handleHideLoadingPopup();
					this.refetch();
				})
				.catch(e => {
					this.props.handleHideLoadingPopup();
				})
        });
    }

    @autobind
    handleDeleteArchive(name) {

        const { dispatch } = this.props;

        this.props.handleShowLoadingPopup('삭제 중입니다.');
        let formdata = new FormData()
        formdata.append("name", name)
        fetch(addPrefix("/manage/design/skin/delete.json"), {
            credentials: 'include',
            method: 'post',
            body: formdata
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleHideLoadingPopup();
                this.refetch();
            })
            .catch(e => {
                this.props.handleHideLoadingPopup();
                console.error(e)
                // this.props.handleShowErrorToastPopup('저장된 스킨 삭제에 실패했습니다.', '다시 시도해 주세요.')
            });
    }

    @autobind
    handleSetSkin(skinName) {

      if(!confirm(CONFIRM_CHANGE_SKIN_MSG))
        return false;

        const { dispatch } = this.props;

        this.props.handleShowLoadingPopup('적용 중입니다.');
        let formdata = new FormData()
        formdata.append("name", skinName)
        fetch(addPrefix("/manage/design/skin/set.json"), {
            credentials: 'include',
            method: 'post',
            body: formdata
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleHideLoadingPopup();
                this.refetch();
                window.scrollTo(0, 0)
            })
            .catch(e => {
                this.props.handleHideLoadingPopup();
                console.error(e)
                // this.props.handleShowErrorToastPopup('스킨 적용에 실패했습니다.', '다시 시도해 주세요.')
            });
    }

    render() {
        const { initialized, archiveList } = this.state;

            return (
                <div id="mArticle">
                    <div className="inner_article decoration_article">
                        <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
                        { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
                        { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
                        { (initialized === InitStatus.INIT_SUCCESS ) &&
                            <div className="blog_skin">
								<h3 className="tit_cont">사용중인 스킨</h3>
								<CurrentSkin currentSkin={this.state.currentSkin} handleArchive={this.handleArchive} history={this.props.history} />

								<h3 className="tit_cont">
									스킨 보관함
									<label className="lab_btn lab_add">
										스킨 등록
										<input type="button" className="btn_g" value="스킨 등록" onClick={this.handleSkinAdd} />
									</label>
								</h3>

								<div ref="root" className="wrap_search">
									<p className="txt_search">블로그 스킨을 변경하거나 저장할 수 있고, 직접 업로드한 스킨을 적용할 수 있습니다.</p>
									<Link to="/design/skin" className="link_storage">스킨 목록<span className="ico_blog ico_arr"></span></Link>
								</div>

								<strong className="screen_out">스킨 목록</strong>

								{ archiveList.length === 0 &&
									<div className="box_blog info_none">
										<p className="txt_none">
											<span className="wrap_ico"><span className="ico_blog ico_post"/></span>
											보관된 스킨이 없습니다.
										</p>
									</div>
								}

								{ archiveList.length > 0 &&
									<div className="list_skin">
										{ archiveList.map((skin, index) =>
											<SkinCard key={index} skin={skin} type={ARCHIVE} onSetSkin={this.handleSetSkin} deleteArchive={this.handleDeleteArchive} currentSkin={this.state.currentSkin} />
										)}
									</div>
								}
							</div>
						}
                        { (initialized === InitStatus.INIT_SUCCESS ) &&
                            <SkinPopupLayer refetch={this.refetch}/>
                        }
                        </div>
                </div>
            )
    }
}

export default SkinArchiveListApp;
